<template>
  <div class="contacts-page p-4">
    <h4 class="page-title mb-4">Contact Messages</h4>

    <div v-if="loading" class="text-center py-5 text-muted">
      <div class="spinner-border text-warning" role="status"></div>
      <p class="mt-2">Loading messages...</p>
    </div>

    <div v-else>
      <div v-if="messages.length" class="messages-list">
        <div v-for="m in messages" :key="m.id" class="message-card mb-3 shadow-sm" :class="{ 'read': m.isRead }">
          <div class="d-flex justify-content-between align-items-start mb-2">
            <div class="message-subject">{{ m.subject }}</div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" v-model="m.isRead" @change="toggleRead(m)"/>
              <label class="form-check-label">Read</label>
            </div>
          </div>

          <div class="message-body mb-2">{{ m.message }}</div>

          <div class="message-sender text-muted d-flex justify-content-between align-items-center">
            <div>
              <strong>{{ m.fullName }}</strong> &lt;{{ m.email }}&gt;
            </div>
            <button class="btn btn-sm btn-outline-danger delete-btn" @click="confirmDelete(m.id)">
              <i class="bi bi-trash"></i>
            </button>
          </div>
        </div>
      </div>

      <div v-else class="text-center text-muted py-4">
        <i class="bi bi-envelope-exclamation fs-4 d-block mb-2"></i>
        No contact messages found.
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { useToast } from "vue-toastification";

export default {
  computed: {
    ...mapGetters("contactsAdmin", ["allMessages", "isLoading"]),
    messages() {
      return this.allMessages;
    },
    loading() {
      return this.isLoading;
    },
  },
  methods: {
    ...mapActions("contactsAdmin", ["fetchMessages", "updateMessageReadStatus", "deleteMessage"]),
    async toggleRead(message) {
      const toast = useToast();
      try {
        await this.updateMessageReadStatus({
          id: message.id,
          isRead: message.isRead,
        });
        toast.success(
          message.isRead
            ? "📩 Mesaj okundu olarak işaretlendi."
            : "📭 Mesaj okunmadı olarak işaretlendi."
        );
      } catch (error) {
        console.error(error);
        toast.error("❌ Okundu/Okunmadı işlemi sırasında hata oluştu!");
      }
    },
    async confirmDelete(id) {
      const toast = useToast();
      if (confirm("Bu mesajı silmek istediğine emin misin?")) {
        try {
          await this.deleteMessage(id);
          toast.success("🗑️ Mesaj başarıyla silindi!");
        } catch (error) {
          console.error(error);
          toast.error("❌ Mesaj siliminde bir hata oluştu!");
        }
      }
    },
  },
  mounted() {
    this.fetchMessages();
  },
};
</script>

<style scoped>
.contacts-page {
  font-family: "Poppins", sans-serif;
  color: #333;
}
.page-title {
  color: #c89d43;
  font-weight: 600;
  letter-spacing: 0.3px;
}
.message-card {
  background-color: #fff;
  border-left: 4px solid #c89d43;
  border-radius: 8px;
  padding: 12px 16px;
  transition: transform 0.2s, box-shadow 0.2s, background-color 0.3s;
}
.message-card.read {
  background-color: #b1afaf;
  border-left-color: #727272;
}
.message-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}
.message-sender {
  font-size: 0.85rem;
  color: #777;
  border-top: 1px dashed #e0d7c0;
  padding-top: 6px;
}
.delete-btn {
  border-radius: 50%;
  width: 30px;
  height: 30px;
  padding: 0;
}
.delete-btn i {
  font-size: 1rem;
}
</style>
